import { ArrowRight, MessageCircle } from "lucide-react";
import { trackContact } from "@/lib/tracking";

export default function FinalCTA({ data, footer }) {
  const image = data?.image_url || "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=2400&q=80";
  const headline = data?.headline || "Let's create something unforgettable.";
  const highlight = data?.highlight || "";
  const subheadline = data?.subheadline || "";
  const cta = data?.cta || { label: "Book a Consultation", href: "#contact" };
  const secondary = data?.secondary_cta || { label: "Chat on WhatsApp", href: "whatsapp" };

  const waHref = footer?.whatsapp_number
    ? `https://wa.me/${footer.whatsapp_number}?text=${encodeURIComponent(footer.whatsapp_message || "Hi Weddings by Mostash, I'm planning my wedding and would love to know how you can help.")}`
    : null;

  const secondaryHref = secondary.href === "whatsapp" && waHref ? waHref : secondary.href;
  const isWhatsapp = secondary.href === "whatsapp";

  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden text-ivory">
      <div className="absolute inset-0">
        <img src={image} alt="Wedding moment" className="h-full w-full object-cover animate-ken-burns" loading="lazy" />
        <div className="absolute inset-0 bg-charcoal/65" />
      </div>
      <div className="relative max-w-5xl mx-auto px-5 md:px-10 py-24 md:py-40 text-center">
        <h2
          data-testid="final-cta-headline"
          className="reveal font-display text-[2.4rem] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl tracking-tight"
        >
          {headline}
          {highlight ? (<><br /><em className="italic font-light text-gold not-italic">{highlight}</em></>) : null}
        </h2>
        {subheadline ? (
          <p className="reveal mt-6 md:mt-8 max-w-2xl mx-auto text-base md:text-lg leading-relaxed text-ivory/85 font-light">
            {subheadline}
          </p>
        ) : null}
        <div className="reveal mt-9 md:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <a
            href={cta.href}
            data-testid="final-cta-button"
            className="btn-gold inline-flex group"
          >
            {cta.label}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
          </a>
          {secondaryHref ? (
            <a
              href={secondaryHref}
              target={isWhatsapp ? "_blank" : undefined}
              rel={isWhatsapp ? "noopener noreferrer" : undefined}
              onClick={() => { if (isWhatsapp) trackContact("whatsapp", { source_section: "final_cta" }); }}
              data-testid="final-cta-secondary"
              className="inline-flex items-center justify-center gap-2 h-12 px-7 border border-ivory/40 text-ivory text-[11.5px] uppercase tracking-[0.22em] font-medium hover:bg-ivory hover:text-charcoal transition-colors"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={1.5} />
              {secondary.label}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
